export type ChangelogProductId =
  | 'auth'
  | 'balance'
  | 'signal'
  | 'identity'
  | 'transfer'
  | 'investments-move'
  | 'payment-initiation'
  | 'transactions'
  | 'investments'
  | 'liabilities'
  | 'enrich'
  | 'identity-verification'
  | 'monitor'
  | 'protect'
  | 'layer'
  | 'check'
  | 'assets'
  | 'income'
  | 'statements'
  | 'mobile-sdks'
  | 'partners'
  | 'legacy'
  | 'general';

export type ChangelogProductCategory =
  | 'Payments and Funding'
  | 'Financial Insights'
  | 'KYC/AML and anti-fraud'
  | 'Credit and Underwriting'
  | 'Instant Onboarding'
  | 'Other';

export const CATEGORY_ORDER: ReadonlyArray<ChangelogProductCategory> = [
  'Payments and Funding',
  'Financial Insights',
  'KYC/AML and anti-fraud',
  'Credit and Underwriting',
  'Instant Onboarding',
  'Other',
];

export type ChangelogProduct = {
  id: ChangelogProductId;
  label: string;
  category: ChangelogProductCategory;
};

export const GENERAL_PRODUCT_ID: ChangelogProductId = 'general';
export const LEGACY_PRODUCT_ID: ChangelogProductId = 'legacy';

export const PRODUCTS: ReadonlyArray<ChangelogProduct> = [
  { id: 'auth', label: 'Auth', category: 'Payments and Funding' },
  { id: 'balance', label: 'Balance', category: 'Payments and Funding' },
  { id: 'signal', label: 'Signal', category: 'Payments and Funding' },
  { id: 'identity', label: 'Identity', category: 'Payments and Funding' },
  { id: 'transfer', label: 'Transfer', category: 'Payments and Funding' },
  {
    id: 'investments-move',
    label: 'Investments Move',
    category: 'Payments and Funding',
  },
  {
    id: 'payment-initiation',
    label: 'Payments (Europe)',
    category: 'Payments and Funding',
  },
  {
    id: 'transactions',
    label: 'Transactions',
    category: 'Financial Insights',
  },
  { id: 'investments', label: 'Investments', category: 'Financial Insights' },
  { id: 'liabilities', label: 'Liabilities', category: 'Financial Insights' },
  { id: 'enrich', label: 'Enrich', category: 'Financial Insights' },
  {
    id: 'identity-verification',
    label: 'Identity Verification',
    category: 'KYC/AML and anti-fraud',
  },
  { id: 'monitor', label: 'Monitor', category: 'KYC/AML and anti-fraud' },
  { id: 'protect', label: 'Protect', category: 'KYC/AML and anti-fraud' },
  {
    id: 'check',
    label: 'Consumer Report (by Plaid Check)',
    category: 'Credit and Underwriting',
  },
  { id: 'assets', label: 'Assets', category: 'Credit and Underwriting' },
  { id: 'income', label: 'Income', category: 'Credit and Underwriting' },
  {
    id: 'statements',
    label: 'Statements',
    category: 'Credit and Underwriting',
  },
  { id: 'layer', label: 'Layer', category: 'Instant Onboarding' },
  {
    id: 'mobile-sdks',
    label: 'Link SDKs (iOS / Android / React Native / React)',
    category: 'Other',
  },
  { id: 'partners', label: 'Partners', category: 'Other' },
  { id: 'general', label: 'General updates', category: 'Other' },
];
